import { C as CosmosIconExternalLink$1, d as defineCustomElement$1 } from './p-DQOdx1O-.js';

const CosmosIconExternalLink = CosmosIconExternalLink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconExternalLink, defineCustomElement };
